import { render } from "./TaxCreateComponent.vue?vue&type=template&id=217bd3cb"
import script from "./TaxCreateComponent.vue?vue&type=script&lang=js"
export * from "./TaxCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Tax/TaxCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "217bd3cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('217bd3cb', __exports__)) {
    api.reload('217bd3cb', __exports__)
  }
  
  module.hot.accept("./TaxCreateComponent.vue?vue&type=template&id=217bd3cb", () => {
    api.rerender('217bd3cb', render)
  })

}


export default __exports__